<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title15"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title15"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439633106_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439633106_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<a class="toc_entry_acknowPage" href="#/e9781439633106_ack01"><span>ACKNOWLEDGMENTS</span></a><br/>
<a class="toc_entry_forewordPage" href="#/e9781439633106_frw01"><span>FOREWORD</span></a><br/>
<a class="toc_entry_chapter" href="#/e9781439633106_c01"><span><em class="i">One</em> - THE BEGINNING</span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c02" title="Link target outside of Sample"><span><em class="i">Two</em> - THE PURPLE GANG</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c03" title="Link target outside of Sample"><span><em class="i">Three</em> - THE COMBINATION</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c04" title="Link target outside of Sample"><span><em class="i">Four</em> - THE ZERILLI ERA</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c05" title="Link target outside of Sample"><span><em class="i">Five</em> - HOFFA</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c06" title="Link target outside of Sample"><span><em class="i">Six</em> - PASSING OF THE TORCH</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c07" title="Link target outside of Sample"><span><em class="i">Seven</em> - THE NEW GENERATION</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633106_c08" title="Link target outside of Sample"><span><em class="i">Eight</em> - TODAY, THE FUTURE, AND BEYOND</span></span><br/>
<span class="toc_entry_backMatter" href="#/e9781439633106_bm01" title="Link target outside of Sample"><span>BIBLIOGRAPHY</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439633106_toc01.vue?01d8133c